module.exports = __webpack_public_path__ + "img/wx_login_explain.16069bc6.png";